import { useCallback, useMemo, useState } from "react"

import type { EmailAttachment } from "@productlane/api"

import { emailBodyChunks, emailTextFlags } from "@/lib/email-body"

export const useMailCollapse = (
	htmlContent: string,
	attachments: EmailAttachment[],
	defaultExpanded = false,
) => {
	const htmlMailChunks = useMemo(() => {
		const { visible, hidden } = emailBodyChunks(htmlContent, attachments)
		return [visible, hidden] as [string, string]
	}, [htmlContent, attachments])

	const hasVisibleText = emailTextFlags(htmlMailChunks[0]).hasText

	const [isCollapsed, collapse] = useState(
		() => hasVisibleText && !defaultExpanded,
	)

	const toggleCollapse = useCallback(() => {
		collapse((prevState) => !prevState)
	}, [])

	return { isCollapsed, toggleCollapse, htmlMailChunks }
}
